import styled from 'styled-components';

const ProductInformation = ({
  productName,
  stockCode,
  partCode,
  stockLevel,
}) => (
  <>
    <p>{productName}</p>
    <CodesSection className="fl">
      <p>
        <span className="fw-400 tc-grey-70">Stock Code </span>
        <BoldSpan className="mr-16">{stockCode}</BoldSpan>
      </p>
      <p>
        <span className="fw-400 tc-grey-70">Part Code </span>
        <BoldSpan className="mr-16">{partCode}</BoldSpan>
      </p>
    </CodesSection>
    <p>
      <BoldSpan>{stockLevel} </BoldSpan>
      in stock
    </p>
  </>
);

const BoldSpan = styled.span`
  font-weight: 500;
`;

const CodesSection = styled.div`
  flex-direction: column;
  @media only screen and (min-width: 768px) {
    flex-direction: row;
  }
`;

export default ProductInformation;
